// extracted by mini-css-extract-plugin
module.exports = {"container":"Investors_container__1LqrH","card":"Investors_card__3Wbq2","cardDetail":"Investors_cardDetail__sx5c1"};